export enum SLIDE_TYPE {
    NONE = 'None',
    PRODUCT = 'Product',
    CATEGORY = 'Category',
    WEB = 'Web'
}
